/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Statistics } from './Statistics';
import {
    instanceOfStatistics,
    StatisticsFromJSON,
    StatisticsFromJSONTyped,
    StatisticsToJSON,
} from './Statistics';

/**
 * @type NumericDataSetDtoStatistics
 * 
 * @export
 */
export type NumericDataSetDtoStatistics = Statistics;


export function NumericDataSetDtoStatisticsFromJSON(json: any): NumericDataSetDtoStatistics {
    return NumericDataSetDtoStatisticsFromJSONTyped(json, false);
}

export function NumericDataSetDtoStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericDataSetDtoStatistics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...StatisticsFromJSONTyped(json, true) };
    return  StatisticsFromJSONTyped(json, true);
}

export function NumericDataSetDtoStatisticsToJSON(value?: NumericDataSetDtoStatistics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfStatistics(value)) {
        return StatisticsToJSON(value as Statistics);
    }

    return {};
}

/**
 * Check if a given object implements the NumericDataSetDtoStatistics interface.
 */
export function instanceOfNumericDataSetDtoStatistics(value: any): value is NumericDataSetDtoStatistics {
    if (instanceOfStatistics(value)) return true;
    return false;
}

